<div class="footer">
  <p>This is your footer</p>
</div>
